/**
 * bubu-caja.js — reposicionamiento de la rejilla «Lo que llevas».
 *
 * Nunca se añade nada a ciegas: al añadir, la rejilla se desplaza LO MÍNIMO para que la
 * fila nueva quede entera abajo, de modo que siga asomando la fila anterior. No se
 * cuadra a filas completas: el contenedor no mide un número entero de filas y redondear
 * sube la fila nueva al borde superior y esconde lo ya añadido.
 *
 * Si el hueco recién llenado ya se veía, no se mueve nada. Se mide con
 * getBoundingClientRect, no con offsetTop, para no depender de cuál sea el offsetParent.
 *
 * Vale para las dos superficies: la tarjeta de PC y la hoja móvil.
 */

/** Ancestro con scroll de un nodo (la tarjeta de PC scrollea en .bubu-caja__scroll; la hoja, en su cuerpo). */
function contenedorScroll(nodo) {
  let n = nodo.parentElement;
  while (n && n !== document.body) {
    const ov = getComputedStyle(n).overflowY;
    if ((ov === 'auto' || ov === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    n = n.parentElement;
  }
  return null;
}

function rejillaViva() {
  // Con la hoja abierta manda la suya, aunque la tarjeta de PC siga en el DOM.
  const hoja = document.querySelector('.bubu-hoja--caja:not([hidden])');
  const dentroDeLaHoja = hoja && hoja.querySelector('[data-bubu-slots]');
  if (dentroDeLaHoja && dentroDeLaHoja.clientHeight > 0) return dentroDeLaHoja;
  return [...document.querySelectorAll('[data-bubu-slots]')].filter((g) => g.clientHeight > 0 && g.children.length)[0];
}

function verUltimoAnadido(instantaneo) {
  const grid = rejillaViva();
  if (!grid) return;
  const llenos = grid.querySelectorAll('.bubu-slot.is-lleno');
  const el = llenos[llenos.length - 1];
  if (!el) return;
  const cont = contenedorScroll(grid);
  if (!cont) return;

  const rc = cont.getBoundingClientRect();
  const re = el.getBoundingClientRect();
  const alto = re.height;
  const gap = parseFloat(getComputedStyle(grid).rowGap) || 8;
  const paso = alto + gap;
  const top = re.top - rc.top + cont.scrollTop;
  const bot = top + alto;
  const ch = cont.clientHeight;

  let y = cont.scrollTop;
  if (bot > y + ch) y = bot - ch;
  else if (top < y) y = Math.max(0, top - paso);
  y = Math.max(0, y);
  if (Math.abs(y - cont.scrollTop) < 1) return;

  if (instantaneo) {
    const antes = cont.style.scrollBehavior;
    cont.style.scrollBehavior = 'auto';
    cont.scrollTop = y;
    setTimeout(() => {
      cont.style.scrollBehavior = antes || '';
    }, 160);
  } else {
    cont.scrollTop = y;
  }
}

let t = null;
document.addEventListener('bubu:cart', (e) => {
  // Solo cuando se ha añadido algo: al quitar no se mueve la vista.
  if (e.detail && e.detail.quitando) return;
  clearTimeout(t);
  t = setTimeout(() => verUltimoAnadido(false), 90);
});

// Al abrir la hoja, su lista nace desde arriba: se coloca de golpe sobre el último
// añadido, sin animación de scroll, para que se vea lo que ya llevas.
document.addEventListener('bubu:abrir', (e) => {
  if (!e.target || e.target.id !== 'bubu-hoja-caja') return;
  setTimeout(() => verUltimoAnadido(true), 90);
});

window.BubuCaja = { verUltimoAnadido };

/* Hueco vacío «+» con la hoja abierta: en móvil el modal tapa la tienda, así que
   pulsar un hueco vacío significa «quiero seguir eligiendo». Se cierra la hoja y se
   sigue comprando; no se navega a ningún sitio. */
document.addEventListener('click', (e) => {
  const hueco = e.target.closest('[data-bubu-slot-vacio], [data-bubu-caja-vacio]');
  if (!hueco) return;
  const hoja = hueco.closest('bubu-hoja');
  if (!hoja || hoja.hidden || typeof hoja.cerrar !== 'function') return;
  // Si la parrilla de slimes está en esta misma página (la tienda), cerrar la hoja ya
  // deja al cliente delante de ella. Si no lo está, se cierra y el enlace sigue su
  // curso hacia la tienda: nunca se queda mirando una caja vacía sin salida.
  const hayParrilla = !!document.querySelector('[data-bubu-parrilla], .bubu-parrilla');
  if (hayParrilla) e.preventDefault();
  hoja.cerrar();
});

/* ------------------------------------------------------------------
   Una sola «Monta tu caja» en el DOM por anchura, como hace el prototipo: en PC la
   tarjeta pegada del carril; en móvil la hoja. Lo que no se ve no existe, así que no
   se mide, no se repinta y no duplica el trabajo en cada cambio del carrito.
   Al volver a entrar en el DOM se copia el contenido de la que sí estaba viva, que es
   la que bubu-cart.js ha ido actualizando.
   ------------------------------------------------------------------ */
(() => {
  const mq = matchMedia('(max-width: 819.98px)');
  const rail = document.querySelector('[data-bubu-rail]');
  const hoja = document.getElementById('bubu-hoja-caja');
  if (!rail && !hoja) return;
  const anclas = new Map();
  [rail, hoja].forEach((n) => {
    if (n) anclas.set(n, [n.parentNode, n.nextSibling]);
  });
  const pon = (n) => {
    if (!n || n.isConnected) return;
    const [padre, sig] = anclas.get(n);
    padre.insertBefore(n, sig);
    const vivo = [...document.querySelectorAll('[data-bubu-caja-cont]')].find((c) => !n.contains(c));
    const destino = n.querySelector('[data-bubu-caja-cont]');
    if (vivo && destino) destino.innerHTML = vivo.innerHTML;
  };
  const quita = (n) => {
    if (!n || !n.isConnected) return;
    if (n === hoja && !n.hidden) {
      if (typeof n.cerrar === 'function') n.cerrar();
      setTimeout(() => { if (!mq.matches) n.remove(); }, 360);
      return;
    }
    n.remove();
  };
  const sincroniza = () => {
    if (mq.matches) { pon(hoja); quita(rail); }
    else { pon(rail); quita(hoja); }
  };
  sincroniza();
  mq.addEventListener('change', sincroniza);
})();
/* ------------------------------------------------------------------
   Pista de que la lista sigue. «Lo que llevas» se desplaza, y un corte limpio en el
   borde no se lee como «hay más»: se lee como «esto es todo». Con siete Bubus dentro,
   eso era abrir la caja para comprobar lo que llevabas y contar tres.
   El degradado lo pinta el CSS (.is-mas-arriba / .is-mas-abajo); aquí solo se mide.
   ------------------------------------------------------------------ */
function pintaBordes() {
  document.querySelectorAll('.bubu-caja__slots-wrap').forEach((wrap) => {
    const cont = wrap.querySelector('.bubu-caja__scroll');
    if (!cont) return;
    // Dónde empieza la rejilla dentro del envoltorio: debajo de «Lo que llevas», que no
    // mide lo mismo en la tarjeta de PC (12,5 px) que en la hoja (15 px + la píldora de
    // unidades). Con un número fijo, el degradado de arriba caía sobre la etiqueta en
    // vez de sobre los botes. Se mide, no se adivina.
    wrap.style.setProperty('--bubu-rejilla-top', cont.offsetTop + 'px');
    const hay = cont.scrollHeight > cont.clientHeight + 2;
    wrap.classList.toggle('is-mas-arriba', hay && cont.scrollTop > 4);
    wrap.classList.toggle('is-mas-abajo', hay && cont.scrollTop + cont.clientHeight < cont.scrollHeight - 4);
  });
}
document.addEventListener('scroll', (e) => {
  if (e.target instanceof Element && e.target.classList.contains('bubu-caja__scroll')) pintaBordes();
}, true);
addEventListener('resize', pintaBordes, { passive: true });
document.addEventListener('bubu:cart', () => setTimeout(pintaBordes, 120));
document.addEventListener('bubu:abrir', (e) => {
  if (e.target && e.target.id === 'bubu-hoja-caja') setTimeout(pintaBordes, 140);
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintaBordes);
else pintaBordes();

/* ------------------------------------------------------------------
   Aviso de regalo.

   Regalamos un activador en todos los pedidos. Si eso solo se ve como una línea a 0 €
   cuando alguien se asoma al carrito, no se valora: hay que decirlo EN EL MOMENTO en
   que se gana, que es el primer «añadir».

   Qué lo dispara: la aparición de un regalo que antes no estaba. No se escucha «he
   pulsado añadir» sino «hay un regalo nuevo en el carrito», así que da igual por dónde
   se compre —ficha, tienda, packs, extras—: el aviso sale una sola vez y siempre igual.

   Qué NO lo dispara:
     · el primer repintado tras cargar la página (ahí se toma la foto de partida: un
       regalo que ya estaba puesto no es una noticia);
     · los regalos que no son el activador —el mini Bubu de Kite—, que ya vienen dados
       de antes y llevan su marco morado en «Lo que llevas», pero no un aviso encima.
       Es lo que pidió Álvaro: mismo trato de regalo, menos animación.

   El texto y el importe NO se inventan aquí: los deja el servidor en el contenedor de
   «Monta tu caja» o del carrito. Una sola fuente, y la misma frase que sabría montar
   Liquid.

   Y el aviso es LO ÚNICO que anuncia el regalo. Hubo además una franja morada fija
   dentro de la caja y del carrito, que se plegaba sola a los cinco segundos; entre el
   repintado de cada cambio del carrito y los regalos que entran después, acababa
   asomando una y otra vez y comiéndose el sitio de los extras y de los hitos. Fuera.
   Lo que queda contando el regalo el resto de la compra es el hueco con marco morado en
   «Lo que llevas» y su línea «Gratis 4,95 €», que ya lo dicen sin ocupar una franja.
   ------------------------------------------------------------------ */
const SVG_REGALO =
  '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
  '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

const esRegaloLinea = (i) => !!(i && ((i.properties && i.properties._regalo) || i.final_line_price === 0));
const claveRegalo = (i) => String((i.properties && i.properties._regalo) || 'v' + (i.variant_id || i.id));
const regalosDe = (cart) => new Set(((cart && cart.items) || []).filter(esRegaloLinea).map(claveRegalo));

let regalosVistos = null;

// Foto del regalo: la del hueco morado de «Lo que llevas» o la de su línea del carrito,
// las dos ya pintadas por el servidor. Si no hay ninguna, el aviso va sin foto y sigue
// diciendo lo que tiene que decir.
function fotoRegalo(variantId) {
  const sel = variantId ? `[data-bubu="caja-regalo"][data-variant-id="${variantId}"] img` : '';
  const img =
    (sel && document.querySelector(sel)) ||
    document.querySelector('[data-bubu="caja-regalo"] img') ||
    document.querySelector('.bubu-cesta__linea--regalo img');
  return img ? img.currentSrc || img.src : '';
}

// La frase y el importe los deja el servidor en el contenedor de «Monta tu caja» o del
// carrito (data-bubu-regalo-frase / -valor). Antes se leían de la franja morada que se
// pintaba dentro de la caja; esa franja ya no existe —el regalo se anuncia una sola vez,
// aquí, y no ocupa sitio el resto de la compra— pero el dato sigue estando, así que el
// aviso puede decir CUÁL es el regalo y lo que vale en vez de una frase genérica.
function datoRegalo(campo) {
  const n = document.querySelector('[data-bubu-regalo-' + campo + ']');
  const v = n && n.getAttribute('data-bubu-regalo-' + campo);
  return v ? v.trim() : '';
}

function avisoRegalo(item) {
  const titulo = datoRegalo('frase') || 'Bubu te ha regalado un activador.';
  const valor = datoRegalo('valor');
  const foto = fotoRegalo(item && (item.variant_id || item.id));

  document.querySelectorAll('.bubu-toast-regalo').forEach((t) => t.remove());
  const t = document.createElement('div');
  t.className = 'bubu-toast-regalo';
  t.setAttribute('role', 'status');
  t.innerHTML =
    '<span class="bubu-toast-regalo__ico">' + SVG_REGALO + '</span>' +
    '<span class="bubu-toast-regalo__txt">' +
    '<span class="bubu-toast-regalo__t"></span>' +
    '<span class="bubu-toast-regalo__s"><b class="bubu-toast-regalo__gratis">Gratis</b><s class="bubu-precio bubu-precio--tachado" hidden></s></span>' +
    '</span>' +
    (foto ? '<span class="bubu-toast-regalo__foto"><img src="' + foto + '" alt="" decoding="async"></span>' : '');
  // Título e importe por textContent: vienen de la página, pero nunca se mete texto
  // ajeno en el HTML de un nodo nuevo si se puede evitar.
  t.querySelector('.bubu-toast-regalo__t').textContent = titulo;
  if (valor) {
    const s = t.querySelector('.bubu-toast-regalo__s s');
    s.textContent = valor;
    s.hidden = false;
  }
  // Debajo de la cabecera pegajosa, no encima: con un `top` fijo el aviso caía sobre el
  // logo y el icono del carrito y no se leía ni lo uno ni lo otro. Se mide la cabecera
  // en el momento (con la página arriba del todo lleva la barra de avisos encima, y al
  // bajar se queda pegada en 0) y se limita a 120 px para que nunca baje demasiado.
  const cab = document.querySelector('.bubu-seccion-cabecera, .bubu-cab');
  const y = cab ? Math.min(120, Math.max(0, cab.getBoundingClientRect().bottom)) : 0;
  t.style.top = 'calc(' + Math.round(y + 12) + 'px + env(safe-area-inset-top))';
  document.body.appendChild(t);

  // Al irse, el aviso no se desvanece en el sitio: se va HACIA el activador y se encoge
  // dentro de él, como si el hueco de «Lo que llevas» (o la línea del carrito, o el
  // icono del carrito si no hay nada de eso a la vista) se lo tragara. Así se entiende
  // sin leer que el aviso hablaba de ESE producto y de dónde ha ido a parar.
  // Solo se animan transform y opacity, que van por el compositor: ni un repintado ni
  // un cálculo de layout durante el vuelo. Las medidas se toman una vez, al empezar.
  const aLaVista = (n) => {
    if (!n) return null;
    const r = n.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    if (r.bottom < 8 || r.top > window.innerHeight - 8) return null;
    if (r.right < 8 || r.left > window.innerWidth - 8) return null;
    return r;
  };
  const destino = () => {
    const vid = item && (item.variant_id || item.id);
    const candidatos = [
      vid && document.querySelector('[data-bubu="caja-regalo"][data-variant-id="' + vid + '"]'),
      document.querySelector('[data-bubu="caja-regalo"]'),
      document.querySelector('[data-bubu="linea-regalo"]'),
      document.querySelector('.bubu-cab__pc [data-bubu-abrir-cesta]'),
      document.querySelector('[data-bubu-abrir-cesta]'),
    ];
    for (const n of candidatos) {
      const r = aLaVista(n);
      if (r) return { nodo: n, r };
    }
    return null;
  };
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fin = () => {
    if (t._bubuYendo) return;
    t._bubuYendo = true;
    const d = quieto || typeof t.animate !== 'function' ? null : destino();
    if (!d) {
      t.classList.add('is-yendo');
      setTimeout(() => t.remove(), 260);
      return;
    }
    const o = t.getBoundingClientRect();
    const dx = Math.round(d.r.left + d.r.width / 2 - (o.left + o.width / 2));
    const dy = Math.round(d.r.top + d.r.height / 2 - (o.top + o.height / 2));
    t.style.pointerEvents = 'none';
    const vuelo = t.animate(
      [
        { transform: 'translateX(-50%) translate(0px, 0px) scale(1)', opacity: 1 },
        { transform: 'translateX(-50%) translate(' + Math.round(dx * 0.35) + 'px, ' + Math.round(dy * 0.28) + 'px) scale(0.86)', opacity: 0.92, offset: 0.45 },
        { transform: 'translateX(-50%) translate(' + dx + 'px, ' + dy + 'px) scale(0.14)', opacity: 0 },
      ],
      { duration: 460, easing: 'cubic-bezier(0.5, 0, 0.75, 0.3)', fill: 'forwards' }
    );
    vuelo.onfinish = () => t.remove();
    // Y el destino acusa el golpe: un latido corto justo cuando llega. Sin esto el vuelo
    // se ve pero no se entiende que ha aterrizado ahí.
    setTimeout(() => {
      if (typeof d.nodo.animate !== 'function') return;
      d.nodo.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }],
        { duration: 300, easing: 'ease-out' }
      );
    }, 380);
  };
  const reloj = setTimeout(fin, 3600);
  t.addEventListener('click', () => {
    clearTimeout(reloj);
    fin();
  });
}

document.addEventListener('bubu:cart', (e) => {
  const cart = e.detail && e.detail.cart;
  if (!cart) return;
  const ahora = regalosDe(cart);
  if (!regalosVistos) {
    regalosVistos = ahora;
    return;
  }
  const nuevos = [...ahora].filter((k) => !regalosVistos.has(k));
  regalosVistos = ahora;
  if (!nuevos.length) return;
  if (!nuevos.includes('activador')) return;
  const item = (cart.items || []).find((i) => i.properties && i.properties._regalo === 'activador');
  avisoRegalo(item);
});

// Foto de partida en cuanto bubu-cart.js tiene el carrito: lo que ya estaba puesto al
// llegar no es un regalo nuevo. Si el cliente es más rápido que la red, el primer
// bubu:cart hace de foto de partida y no se avisa: mejor callar de más que celebrar
// algo que ya estaba.
(() => {
  let intentos = 0;
  const mira = () => {
    if (regalosVistos) return;
    const c = window.BubuCart && window.BubuCart.cart;
    if (c) {
      regalosVistos = regalosDe(c);
      return;
    }
    if (++intentos < 25) setTimeout(mira, 200);
  };
  mira();
})();
